import { produce } from 'immer'
import I00DebgazReducer from '../Calculs/I00DebgazReducer'
import I00RELGAZPUISSReducer from '../Calculs/I00RELGAZPUISSReducer'
import I00DIMLIGNEGAZReducer from '../Calculs/I00DIMLIGNEGAZReducer'
import I01EVACONSSYSTECSReducer from '../Calculs/I01EVACONSSYSTECSReducer'
import I01EVACONSSYSTECS2Reducer from '../Calculs/I01EVACONSSYSTECS2Reducer'
import I01EVAECSQUALIReducer from '../Calculs/I01EVAECSQUALIReducer'
import I01EVAECSQUALI2Reducer from '../Calculs/I01EVAECSQUALI2Reducer'
import I01EVAECSQUALI3Reducer from '../Calculs/I01EVAECSQUALI3Reducer'
import I01DEPBOUCECSReducer from '../Calculs/I01DEPBOUCECSReducer'
import I01TEMPATTReducer from '../Calculs/I01TEMPATTReducer'
import I02COSTENERReducer from '../Calculs/I02COSTENERReducer'
import I02CHOIXENERCHAUFReducer from '../Calculs/I02CHOIXENERCHAUFReducer'
import I03PSYCHROAIRReducer from '../Calculs/I03PSYCHROAIRReducer'
import I04DIMPUISSCHAUDReducer from '../Calculs/I04DIMPUISSCHAUDReducer'
import I04DIMPUISCONSReducer from '../Calculs/I04DIMPUISCONSReducer'
import I04CONVVOLENERReducer from '../Calculs/I04CONVVOLENERReducer'
import I04CONCLIMCONSReducer from '../Calculs/I04CONCLIMCONSReducer'
import I04CONSCHAUFANReducer from '../Calculs/I04CONSCHAUFANReducer'
import I06SEPHYDReducer from '../Calculs/I06SEPHYDReducer'
import I09DIMCIRCReducer from '../Calculs/I09DIMCIRCReducer'
import I07CALCPUISSRADReducer from '../Calculs/I07CALCPUISSRADReducer'
import I08CALCVOLEXPReducer from '../Calculs/I08CALCVOLEXPReducer'
import I10DIABOUCECSReducer from '../Calculs/I10DIABOUCECSReducer'
import I10DIAMPUISSReducer from '../Calculs/I10DIAMPUISSReducer'
import I11PERCHADISCHAReducer from '../Calculs/I11PERCHADISCHAReducer'
import I11PERCHARESReducer from '../Calculs/I11PERCHARESReducer'
import I11PERCHARVARIReducer from '../Calculs/I11PERCHARVARIReducer'
import I12VOLINSTCHAUFReducer from '../Calculs/I12VOLINSTCHAUFReducer'
import I13VENTCHAUFFIOULReducer from '../Calculs/I13VENTCHAUFFIOULReducer'
import I13VENTCHAUFGAZReducer from '../Calculs/I13VENTCHAUFGAZReducer'
import I14V3VREGULReducer from '../Calculs/I14V3VREGULReducer'
import I14V2VREGULReducer from '../Calculs/I14V2VREGULReducer'
import I16DIMADOUCISSEURECSReducer from '../Calculs/I16DIMADOUCISSEURECSReducer'
import I16DIMADOUCISSEURPRIMReducer from '../Calculs/I16DIMADOUCISSEURPRIMReducer'
import I17TARIFC16Reducer from '../Calculs/I17TARIFC16Reducer'
import I17INFPARCONSEPReducer from '../Calculs/I17INFPARCONSEPReducer'
import I18VENTGAINEReducer from '../Calculs/I18VENTGAINEReducer'

import { CalculsType } from './CalculsType'
import { doCalcul } from '@batical/formula/src'
//Added from generator
import I21RENDETASReducer from '../Calculs/I21RENDETASReducer'
import I04CALCULGSIMPReducer from '../Calculs/I04CALCULGSIMPReducer'
import I04CALCULGDETAReducer from '../Calculs/I04CALCULGDETAReducer'
import I04CALCULGDETAItemReducer from '../Calculs/I04CALCULGDETAItemReducer'
import P01CREALOGCOLReducer from '../Projects/P01CREALOGCOLReducer'
import { CalculCodeState, CalculCodeStateKeys, CalculContextState, ProjectDocument, ProjectDocumentFolder } from '@batical/types/src'
import { ProjetCommon_Address } from '@batical/types/src/ProjectCommonState'
import { v4 as uuidv4 } from 'uuid'
import I15MASVOLAPHUMLReducer from '../Calculs/I15MASVOLAPHUMLReducer'
import I15TEMPRELEVEReducer from '../Calculs/I15TEMPRELEVEReducer'
import I15HYDROACCUReducer from '../Calculs/I15HYDROACCUReducer'
import I15TEMPLIMITBOISReducer from '../Calculs/I15TEMPLIMITBOISReducer'
import I15DIMSILOBOISReducer from '../Calculs/I15DIMSILOBOISReducer'
import I15TAUXCOUVBOISReducer from '../Calculs/I15TAUXCOUVBOISReducer'
import I13VENTCHAUFBOISReducer from '../Calculs/I13VENTCHAUFBOISReducer'
import { CalculState } from './CalculsState'
import { sendError } from '@batical/common'
import I10DIAEFCOLReducer from '../Calculs/I10DIAEFCOLReducer'
import PCUSTOMReducer from './PCUSTOMReducer'
//[MARKER_IMPORT]

const initialState: CalculState = {
  section_code: '',
  calcul_code: undefined,
  PCUSTOM: PCUSTOMReducer,
  I00DEBGAZ: I00DebgazReducer,
  I00RELGAZPUISS: I00RELGAZPUISSReducer,
  I00DIMLIGNEGAZ: I00DIMLIGNEGAZReducer,
  I01EVACONSSYSTECS: I01EVACONSSYSTECSReducer,
  I01EVACONSSYSTECS2: I01EVACONSSYSTECS2Reducer,
  I01EVAECSQUALI: I01EVAECSQUALIReducer,
  I01EVAECSQUALI2: I01EVAECSQUALI2Reducer,
  I01EVAECSQUALI3: I01EVAECSQUALI3Reducer,
  I01TEMPATT: I01TEMPATTReducer,
  I01DEPBOUCECS: I01DEPBOUCECSReducer,
  I02CHOIXENERCHAUF: I02CHOIXENERCHAUFReducer,
  I02COSTENER: I02COSTENERReducer,
  I03PSYCHROAIR: I03PSYCHROAIRReducer,
  I04DIMPUISSCHAUD: I04DIMPUISSCHAUDReducer,
  I04DIMPUISCONS: I04DIMPUISCONSReducer,
  I04CONVVOLENER: I04CONVVOLENERReducer,
  I04CONCLIMCONS: I04CONCLIMCONSReducer,
  I04CONSCHAUFAN: I04CONSCHAUFANReducer,
  I06SEPHYD: I06SEPHYDReducer,
  I07CALCPUISSRAD: I07CALCPUISSRADReducer,
  I08CALCVOLEXP: I08CALCVOLEXPReducer,
  I09DIMCIRC: I09DIMCIRCReducer,
  I10DIABOUCECS: I10DIABOUCECSReducer,
  I10DIAMPUISS: I10DIAMPUISSReducer,
  I11PERCHADISCHA: I11PERCHADISCHAReducer,
  I11PERCHARES: I11PERCHARESReducer,
  I11PERCHARVARI: I11PERCHARVARIReducer,
  I12VOLINSTCHAUF: I12VOLINSTCHAUFReducer,
  I13VENTCHAUFFIOUL: I13VENTCHAUFFIOULReducer,
  I13VENTCHAUFGAZ: I13VENTCHAUFGAZReducer,
  I14V3VREGUL: I14V3VREGULReducer,
  I14V2VREGUL: I14V2VREGULReducer,
  I16DIMADOUCISSEURECS: I16DIMADOUCISSEURECSReducer,
  I16DIMADOUCISSEURPRIM: I16DIMADOUCISSEURPRIMReducer,
  I17TARIFC16: I17TARIFC16Reducer,
  I17INFPARCONSEP: I17INFPARCONSEPReducer,

  P01CREALOGCOL: P01CREALOGCOLReducer,
  //added from generator
  I21RENDETAS: I21RENDETASReducer,
  I04CALCULGSIMP: I04CALCULGSIMPReducer,
  I04CALCULGDETA: I04CALCULGDETAReducer,
  I04CALCULGDETAItem: I04CALCULGDETAItemReducer,
  I15MASVOLAPHUML: I15MASVOLAPHUMLReducer,
  I15TEMPRELEVE: I15TEMPRELEVEReducer,
  I15HYDROACCU: I15HYDROACCUReducer,
  I15TEMPLIMITBOIS: I15TEMPLIMITBOISReducer,
  I15DIMSILOBOIS: I15DIMSILOBOISReducer,
  I15TAUXCOUVBOIS: I15TAUXCOUVBOISReducer,
  I13VENTCHAUFBOIS: I13VENTCHAUFBOISReducer,
  I10DIAEFCOL: I10DIAEFCOLReducer,
  //[MARKER_REDUCER]
  I18VENTGAINE: I18VENTGAINEReducer
}

export const initialCalculState: CalculCodeState = {
  PCUSTOM: PCUSTOMReducer,
  I00DEBGAZ: I00DebgazReducer,
  I00RELGAZPUISS: I00RELGAZPUISSReducer,
  I00DIMLIGNEGAZ: I00DIMLIGNEGAZReducer,
  I01EVACONSSYSTECS: I01EVACONSSYSTECSReducer,
  I01EVACONSSYSTECS2: I01EVACONSSYSTECS2Reducer,
  I01EVAECSQUALI: I01EVAECSQUALIReducer,
  I01EVAECSQUALI2: I01EVAECSQUALI2Reducer,
  I01EVAECSQUALI3: I01EVAECSQUALI3Reducer,
  I01TEMPATT: I01TEMPATTReducer,
  I01DEPBOUCECS: I01DEPBOUCECSReducer,
  I02CHOIXENERCHAUF: I02CHOIXENERCHAUFReducer,
  I02COSTENER: I02COSTENERReducer,
  I03PSYCHROAIR: I03PSYCHROAIRReducer,
  I04DIMPUISSCHAUD: I04DIMPUISSCHAUDReducer,
  I04DIMPUISCONS: I04DIMPUISCONSReducer,
  I04CONVVOLENER: I04CONVVOLENERReducer,
  I04CONCLIMCONS: I04CONCLIMCONSReducer,
  I04CONSCHAUFAN: I04CONSCHAUFANReducer,
  I06SEPHYD: I06SEPHYDReducer,
  I07CALCPUISSRAD: I07CALCPUISSRADReducer,
  I08CALCVOLEXP: I08CALCVOLEXPReducer,
  I09DIMCIRC: I09DIMCIRCReducer,
  I10DIABOUCECS: I10DIABOUCECSReducer,
  I10DIAMPUISS: I10DIAMPUISSReducer,
  I11PERCHADISCHA: I11PERCHADISCHAReducer,
  I11PERCHARES: I11PERCHARESReducer,
  I11PERCHARVARI: I11PERCHARVARIReducer,
  I12VOLINSTCHAUF: I12VOLINSTCHAUFReducer,
  I13VENTCHAUFFIOUL: I13VENTCHAUFFIOULReducer,
  I13VENTCHAUFGAZ: I13VENTCHAUFGAZReducer,
  I14V3VREGUL: I14V3VREGULReducer,
  I14V2VREGUL: I14V2VREGULReducer,
  I16DIMADOUCISSEURECS: I16DIMADOUCISSEURECSReducer,
  I16DIMADOUCISSEURPRIM: I16DIMADOUCISSEURPRIMReducer,
  I17TARIFC16: I17TARIFC16Reducer,
  I17INFPARCONSEP: I17INFPARCONSEPReducer,
  P01CREALOGCOL: P01CREALOGCOLReducer,
  //added from generator
  I21RENDETAS: I21RENDETASReducer,
  I04CALCULGSIMP: I04CALCULGSIMPReducer,
  I04CALCULGDETA: I04CALCULGDETAReducer,
  I04CALCULGDETAItem: I04CALCULGDETAItemReducer,
  I15MASVOLAPHUML: I15MASVOLAPHUMLReducer,
  I15TEMPRELEVE: I15TEMPRELEVEReducer,
  I15HYDROACCU: I15HYDROACCUReducer,
  I15TEMPLIMITBOIS: I15TEMPLIMITBOISReducer,
  I15DIMSILOBOIS: I15DIMSILOBOISReducer,
  I15TAUXCOUVBOIS: I15TAUXCOUVBOISReducer,
  I13VENTCHAUFBOIS: I13VENTCHAUFBOISReducer,
  I10DIAEFCOL: I10DIAEFCOLReducer,
  //[MARKER_REDUCER]
  I18VENTGAINE: I18VENTGAINEReducer
} as CalculCodeState

export const calculReducer = (state: CalculState = initialState, action: CalculAction) =>
  produce(state, draft => {
    try {
      switch (action.type) {
        case CalculsType.RESET:
          draft.section_code = ''
          draft.calcul_code = undefined
          return
        case CalculsType.DEFINE_SECTION:
          draft.section_code = action.payload.section_code
          draft.calcul_code = undefined
          return
        case CalculsType.DEFINE_CALCUL:
          //@ts-ignore
          draft.calcul_code = action.payload.calcul_code
          return

        case CalculsType.REPLACE_STATE: {
          const calculCode = action.payload?.calcul ?? draft.calcul_code
          if (calculCode) {
            //@ts-ignore
            draft[calculCode] = action.payload.value
          }
          return
        }
        case CalculsType.DO_CALCUL: {
          const calculCode = action.payload?.calcul ?? draft.calcul_code
          //@ts-ignore
          draft[calculCode] = { ...draft[calculCode], ...doCalcul(calculCode, draft[calculCode]), invalidated: false }
          return
        }
        case CalculsType.UPDATE_CONTEXT_VALUE: {
          const calculCode = action.payload.calcul
          //@ts-ignore
          draft[calculCode][action.payload.key] = action.payload.value
          if (action.payload.do_calcul) {
            //@ts-ignore
            draft[calculCode] = doCalcul(calculCode, draft[calculCode])
          } else {
            //@ts-ignore
            draft[calculCode] = doCalcul(calculCode, draft[calculCode]) //.invalidated = true
          }
          return
        }
        case CalculsType.UPDATE_CONTEXT: {
          //@ts-ignore
          const calculCode = action.payload?.calcul ?? draft.calcul_code

          //@ts-ignore
          draft[calculCode] = doCalcul(calculCode, { ...draft[calculCode], ...action.payload.value, invalidated: false })

          return
        }
        case CalculsType.LOAD_CONTEXT: {
          const context = action.payload.context as any
          //@ts-ignore
          const calculCode = context.calcul_code ?? context.project_code
          //@ts-ignore
          draft.calcul_code = calculCode
          // For PCUSTOM, ensure all fields are properly initialized
          if (calculCode === 'PCUSTOM') {
            //@ts-ignore
            draft[calculCode] = doCalcul(calculCode, {
              ...PCUSTOMReducer,
              ...context,
              calculs: context.calculs || {},
              folders: context.folders || {},
              hasUnsavedChanges: context.hasUnsavedChanges ?? false,
              invalidated: false
            })
          } else {
            // Replace the state entirely instead of merging with defaults - treat all calculs the same way
            //@ts-ignore
            draft[calculCode] = doCalcul(calculCode, { ...context, invalidated: false })
          }

          return
        }

        // PCUSTOM project actions
        case CalculsType.CLEAN_CUSTOM_PROJECT: {
          //@ts-ignore
          draft.PCUSTOM = { ...PCUSTOMReducer }
          return
        }

        case CalculsType.ADD_CALCUL_CUSTOM_PROJECT: {
          //@ts-ignore
          if (!draft.PCUSTOM) {
            //@ts-ignore
            draft.PCUSTOM = { ...PCUSTOMReducer }
          }
          const uuid: string = uuidv4() as string
          //@ts-ignore
          draft.PCUSTOM.calculs[uuid] = {
            ...action.payload.calcul,
            id: uuid,
            name: action.payload.title,
            section: action.payload.section
          }
          //@ts-ignore
          draft.PCUSTOM.hasUnsavedChanges = true
          return
        }

        case CalculsType.REMOVE_CALCUL_CUSTOM_PROJECT: {
          //@ts-ignore
          if (draft.PCUSTOM?.calculs) {
            //@ts-ignore
            delete draft.PCUSTOM.calculs[action.payload]
            //@ts-ignore
            draft.PCUSTOM.hasUnsavedChanges = true
          }
          return
        }

        case CalculsType.UPDATE_PROJECT_NAME: {
          //@ts-ignore
          if (draft.PCUSTOM) {
            //@ts-ignore
            draft.PCUSTOM.projectName = action.payload
            //@ts-ignore
            draft.PCUSTOM.hasUnsavedChanges = true
          }
          return
        }

        case CalculsType.UPDATE_PROJECT_DESCRIPTION: {
          //@ts-ignore
          if (draft.PCUSTOM) {
            //@ts-ignore
            draft.PCUSTOM.description = action.payload
            //@ts-ignore
            draft.PCUSTOM.hasUnsavedChanges = true
          }
          return
        }

        case CalculsType.UPDATE_PROJECT_ADDRESS: {
          //@ts-ignore
          if (draft.PCUSTOM) {
            //@ts-ignore
            draft.PCUSTOM.address = action.payload
            //@ts-ignore
            draft.PCUSTOM.hasUnsavedChanges = true
          }
          return
        }

        case CalculsType.UPDATE_PROJECT_ADDRESS_COMPONENTS: {
          //@ts-ignore
          if (draft.PCUSTOM) {
            //@ts-ignore
            draft.PCUSTOM.addressComponents = action.payload
            //@ts-ignore
            draft.PCUSTOM.hasUnsavedChanges = true
          }
          return
        }

        case CalculsType.UPDATE_PROJECT_AVANCEMENT: {
          //@ts-ignore
          if (draft.PCUSTOM) {
            //@ts-ignore
            draft.PCUSTOM.avancement = action.payload
            //@ts-ignore
            draft.PCUSTOM.hasUnsavedChanges = true
          }
          return
        }

        case CalculsType.ADD_DOCUMENT_FOLDER: {
          //@ts-ignore
          if (!draft.PCUSTOM) {
            //@ts-ignore
            draft.PCUSTOM = { ...PCUSTOMReducer }
          }
          //@ts-ignore
          draft.PCUSTOM.folders[action.payload.id] = action.payload
          return
        }

        case CalculsType.UPDATE_DOCUMENT_FOLDER: {
          //@ts-ignore
          if (draft.PCUSTOM?.folders) {
            //@ts-ignore
            draft.PCUSTOM.folders[action.payload.id] = {
              //@ts-ignore
              ...draft.PCUSTOM.folders[action.payload.id],
              ...action.payload
            }
          }
          return
        }

        case CalculsType.REMOVE_DOCUMENT_FOLDER: {
          //@ts-ignore
          if (draft.PCUSTOM?.folders) {
            //@ts-ignore
            delete draft.PCUSTOM.folders[action.payload]
          }
          return
        }

        case CalculsType.ADD_DOCUMENT: {
          //@ts-ignore
          if (draft.PCUSTOM?.folders?.[action.payload.folderId]) {
            //@ts-ignore
            draft.PCUSTOM.folders[action.payload.folderId].documents[action.payload.doc.id] = action.payload.doc
          }
          return
        }

        case CalculsType.UPDATE_DOCUMENT: {
          //@ts-ignore
          if (draft.PCUSTOM?.folders?.[action.payload.folderId]?.documents) {
            //@ts-ignore
            draft.PCUSTOM.folders[action.payload.folderId].documents[action.payload.doc.id] = {
              //@ts-ignore
              ...draft.PCUSTOM.folders[action.payload.folderId].documents[action.payload.doc.id],
              ...action.payload.doc
            }
          }
          return
        }

        case CalculsType.REMOVE_DOCUMENT: {
          //@ts-ignore
          if (draft.PCUSTOM?.folders?.[action.payload.folderId]?.documents) {
            //@ts-ignore
            delete draft.PCUSTOM.folders[action.payload.folderId].documents[action.payload.id]
          }
          return
        }
      }
    } catch (error) {
      sendError(error, 'calculReducer')
    }
  })

interface DEFINE_SECTION {
  type: CalculsType.DEFINE_SECTION
  payload: { section_code: string }
}
interface DEFINE_CALCUL {
  type: CalculsType.DEFINE_CALCUL
  payload: { calcul_code?: CalculCodeStateKeys }
}
interface RESET {
  type: CalculsType.RESET
}

interface DO_CALCUL {
  type: CalculsType.DO_CALCUL
  payload: { calcul?: CalculCodeStateKeys }
}

interface REPLACE_STATE {
  type: CalculsType.REPLACE_STATE
  payload: { calcul?: CalculCodeStateKeys; value: CalculContextState }
}

interface UPDATE_CONTEXT_VALUE {
  type: CalculsType.UPDATE_CONTEXT_VALUE
  payload: { key: string; calcul: CalculCodeStateKeys; value: string | number | boolean | null; do_calcul: boolean }
}

interface UPDATE_CONTEXT {
  type: CalculsType.UPDATE_CONTEXT
  payload: { value: { [key: string]: string | number | null }; calcul?: CalculCodeStateKeys }
}

interface LOAD_CONTEXT {
  type: CalculsType.LOAD_CONTEXT
  payload: { context: CalculContextState }
}

interface CLEAN_CUSTOM_PROJECT {
  type: CalculsType.CLEAN_CUSTOM_PROJECT
}

interface ADD_CALCUL_CUSTOM_PROJECT {
  type: CalculsType.ADD_CALCUL_CUSTOM_PROJECT
  payload: { calcul: CalculContextState; section: string; title: string }
}

interface REMOVE_CALCUL_CUSTOM_PROJECT {
  type: CalculsType.REMOVE_CALCUL_CUSTOM_PROJECT
  payload: string
}

interface UPDATE_PROJECT_NAME {
  type: CalculsType.UPDATE_PROJECT_NAME
  payload: string
}

interface UPDATE_PROJECT_DESCRIPTION {
  type: CalculsType.UPDATE_PROJECT_DESCRIPTION
  payload: string
}

interface UPDATE_PROJECT_ADDRESS {
  type: CalculsType.UPDATE_PROJECT_ADDRESS
  payload: string | null
}

interface UPDATE_PROJECT_ADDRESS_COMPONENTS {
  type: CalculsType.UPDATE_PROJECT_ADDRESS_COMPONENTS
  payload: ProjetCommon_Address | null
}

interface UPDATE_PROJECT_AVANCEMENT {
  type: CalculsType.UPDATE_PROJECT_AVANCEMENT
  payload: string
}

interface ADD_DOCUMENT_FOLDER {
  type: CalculsType.ADD_DOCUMENT_FOLDER
  payload: ProjectDocumentFolder
}

interface UPDATE_DOCUMENT_FOLDER {
  type: CalculsType.UPDATE_DOCUMENT_FOLDER
  payload: Partial<ProjectDocumentFolder> & { id: string }
}

interface REMOVE_DOCUMENT_FOLDER {
  type: CalculsType.REMOVE_DOCUMENT_FOLDER
  payload: string
}

interface ADD_DOCUMENT {
  type: CalculsType.ADD_DOCUMENT
  payload: { doc: ProjectDocument; folderId: string }
}

interface UPDATE_DOCUMENT {
  type: CalculsType.UPDATE_DOCUMENT
  payload: { doc: Partial<ProjectDocument> & { id: string }; folderId: string }
}

interface REMOVE_DOCUMENT {
  type: CalculsType.REMOVE_DOCUMENT
  payload: { id: string; folderId: string }
}

type CalculAction =
  | DEFINE_SECTION
  | DEFINE_CALCUL
  | RESET
  | DO_CALCUL
  | LOAD_CONTEXT
  | REPLACE_STATE
  | UPDATE_CONTEXT_VALUE
  | UPDATE_CONTEXT
  | CLEAN_CUSTOM_PROJECT
  | ADD_CALCUL_CUSTOM_PROJECT
  | REMOVE_CALCUL_CUSTOM_PROJECT
  | UPDATE_PROJECT_NAME
  | UPDATE_PROJECT_DESCRIPTION
  | UPDATE_PROJECT_ADDRESS
  | UPDATE_PROJECT_ADDRESS_COMPONENTS
  | UPDATE_PROJECT_AVANCEMENT
  | ADD_DOCUMENT_FOLDER
  | UPDATE_DOCUMENT_FOLDER
  | REMOVE_DOCUMENT_FOLDER
  | ADD_DOCUMENT
  | UPDATE_DOCUMENT
  | REMOVE_DOCUMENT
